// extracted by mini-css-extract-plugin
export default {"btn":"DocxDownloadButton_btn__Eel6D","prominent":"DocxDownloadButton_prominent__GxqY5","glyph":"DocxDownloadButton_glyph__BPypR","lock":"DocxDownloadButton_lock__6VB3U"};